<template>
  <div class="robot-list">
    <swiper
      class="promo"
      v-if="adList.length && adStrategyComplete"
      :options="swiperOption"
      ref="mySwiper"
    >
      <swiper-slide v-for="item in adList" :key="item.adName">
        <a @click="openUrl(item.url)" target="_blank">
          <img :src="item.imgSrc" :alt="item.name" />
        </a>
      </swiper-slide>
      <div
        v-if="!isWeixin && adList.length > 1"
        class="swiper-pagination"
        slot="pagination"
      ></div>
      <div
        v-if="adList.length > 1"
        class="swiper-button-prev"
        slot="button-prev"
      ></div>
      <div
        v-if="adList.length > 1"
        class="swiper-button-next"
        slot="button-next"
      ></div>
    </swiper>
    <ul
      v-if="
        robotList.length &&
          Object.keys(runStatusList).length == robotList.length
      "
    >
      <li
        v-for="item in robotList"
        :key="item.ticket"
        :class="{
          cloud: guideType != 'tryout' && item.hasCloud,
          client: guideType != 'tryout' && !item.hasCloud,
          trial: guideType == 'tryout',
        }"
      >
        <div class="hd">
          <em
            :class="{
              red: item.timeRemaining < 3,
            }"
            >{{
              item.timeRemaining > 0
                ? `剩余${item.timeRemaining}天`
                : "已过期"
            }}
            <el-dropdown
              @click.stop.native
              class="expired-dropdown"
              v-show="item.timeRemaining <= -30 && robotList.length > 1"
              size="small"
              @command="(e) => handleCommand(e, item)"
            >
              <el-button type="text" size="mini">
                <span class="fa fa-angle-down" aria-hidden="true"></span>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delete">删除机器人</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </em>
          <i>{{
            item.hasCloud ? "云端" : "电脑"
          }}</i>
          <span>{{ item.label }}</span>
        </div>
        <div
          class="bd"
          :class="{
            'light-cross': runStatusList[item.ticket].runStatus,
            'heart-beat': runStatusList[item.ticket].status == 1,
          }"
        >
          <div
            class="status"
            @click="
              accountList[item.ticket] &&
              isAccountExpire(accountList[item.ticket].timestamp)
                ? accountExpireClick(item)
                : ''
            "
            :class="{
              active: runStatusList[item.ticket].runStatus,
              expired:
                accountList[item.ticket] &&
                isAccountExpire(accountList[item.ticket].timestamp),
            }"
          >
            <i class="icon-loading" v-if="item.cloudLoading"></i
            >{{
              !accountList[item.ticket]
                ? "未配置"
                : isAccountExpire(
                    accountList[item.ticket]
                      ? accountList[item.ticket].timestamp
                      : 0
                  )
                ? "登录过期"
                : runStatusList[item.ticket].runStatus
                ? "已启动"
                : item.cloudLoading
                ? "启动中"
                : "未启动"
            }}
          </div>
          <dl
            @click="accountExpireClick(item)"
            :class="{ 'room-id-filled': item.roomId }"
          >
            <dt>
              <span>{{ item.roomId ? item.huyaUserName : "点击配置" }}</span>
              <small v-if="item.roomId">「{{ item.roomId }}」</small>
              <p @click.stop="openLiveRoom(item.roomId, item.ticket, item)">
                打开房间
              </p>
            </dt>
            <dd
              v-if="
                accountList[item.ticket] &&
                  !isAccountExpire(accountList[item.ticket].timestamp) &&
                  accountList[item.ticket].user
              "
            >
              <i
                v-if="
                  accountList[item.ticket].user.accountType &&
                    accountList[item.ticket].user.accountType != 0 &&
                    accountList[item.ticket].user.accountType != -1
                "
                :class="{
                  'admin-red': accountList[item.ticket].user.accountType != 3,
                  'admin-blue': accountList[item.ticket].user.accountType == 3,
                }"
                >{{
                  accountList[item.ticket].user.accountType == 1 ? "主" : "管"
                }}</i
              >
              <span>{{ accountList[item.ticket].user.name }}</span>
            </dd>
            <dd class="red" v-else>场控号「未配置」</dd>
          </dl>
        </div>
        <div class="ft">
          <ul>
            <li
              @click="
                runStatusList[item.ticket].runStatus
                  ? stopRobot(item)
                  : startRobot(item)
              "
            >
              <i
                :class="{
                  'icon-loading':
                    item.cloudLoading && !runStatusList[item.ticket].runStatus,
                  'icon-stop': runStatusList[item.ticket].runStatus,
                  'icon-play': !runStatusList[item.ticket].runStatus,
                }"
              ></i>
              <span>{{
                runStatusList[item.ticket].runStatus ? "停止" : "启动"
              }}</span>
            </li>
            <li @click="linkToConfig(item.ticket)">
              <i class="icon-config"></i>
              <span>配置</span>
            </li>
            <li @click="linkToRenew(item.ticket)">
              <i class="icon-buy"></i>
              <span>续费</span>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <div
      class="pop mask"
      @click="isShowLogin = false"
      :class="{
        show: isShowLogin,
      }"
    >
      >
      <div class="box add-robot-select" @click.stop>
        <div class="title">
          <span>登录场控号</span>
          <i class="close" @click="isShowLogin = false"></i>
        </div>
        <div class="content">
          <account-login
            v-if="configure && isShowLogin"
            :isCloud="isCloudLogin"
            :configure="configure[ticket]"
            :roomId="roomId"
            :ticket="ticket"
            :isDialog="true"
            @loginStatusChange="loginStatusChange"
            ref="accountlogin"
          ></account-login>
        </div>
      </div>
    </div>
    <div
      class="pop mask"
      @click="isShowFcodeReceive = false"
      :class="{
        show: isShowFcodeReceive,
      }"
    >
      <div class="box award-fcode" @click.stop>
        <div class="title">
          <span>领取奖励</span>
          <i class="close" @click="isShowFcodeReceive = false"></i>
        </div>
        <div class="content">
          <p>
            恭喜您，抽中一张“<span class="green">{{
              this.fcodeReceiveData.pName
            }}</span
            >”:
          </p>
          <div class="fcode">
            <span class="green">{{ this.fcodeReceiveData.FCode }}</span>
          </div>
          <q
            >该F码无法转送他人，请在24小时内领取并使用。<strong
              >使用完F码，要续费机器人才能重新工作哦</strong
            ></q
          >
          <div class="actions">
            <button class="button" @click="fcodeReceive">立即使用</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="pop mask"
      @click="isShowInputRoomId = false"
      :class="{
        show: isShowInputRoomId,
      }"
    >
      >
      <div class="box set-room-id" @click.stop>
        <div class="title">
          <span>配置房间号</span>
          <i class="close" @click="isShowInputRoomId = false"></i>
        </div>
        <div class="content">
          <input-room-id
            ref="inputroomid"
            v-if="isShowInputRoomId"
            :ticket="ticket"
            :isDialog="true"
            @saveCompleted="saveCompleted"
          ></input-room-id>
          <div class="actions">
            <button class="button" @click="save">保存</button>
          </div>
        </div>
      </div>
    </div>
    <pay-box
      ref="dialogpay"
      @dialogClose="dialogPayClose"
      @payCompleted="payCompleted"
      @robotAdd="getUserRobots"
    ></pay-box>
  </div>
</template>

<script>
import {
  userInfo,
  getUserRobotsInfo,
  getRoomName,
  cloudStop,
  getCloudStatus,
  cloudStart,
  getConfig,
  getFeatureList,
  cloudLogin,
  getCloudQrCode,
  checkCloudLogin,
  createWechatPayOrder,
  createWechatPay,
  checkFcodeOrder,
  consumeFCode,
  getFCode,
  passwordLogin,
  updateConfig,
  smsImgInfo,
  smsImgVerify,
  checkAccountType,
  updateAccount,
  delRobot,
  bigAmount,
} from "@/api/index";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import accountLogin from "@/components/accountLogin";
import inputRoomId from "@/components/inputRoomId";
import payBox from "@/components/payBox";
import { getCookie, removeCookie, getQueryString } from "@/utils/query";
import { Message } from "element-ui";
import { mapState, mapActions } from "vuex";
import { deepObjectMerge } from "@/utils/object";
import { commonFuc } from "@/mixins/commonFuc";

let loading = null;
let xcsAdList = [
  {
    adName: "xcsAd1",
    url:
      "https://www.xiaocaishu.com/news/zai-ye-bu-pa-lai-bu-ji-jie-tu-he-zi-zhu-bo-de-fu-yin.html",
    imgSrc: require("../assets/pic/promo/xcs-1.jpg"),
    name: "再也不怕来不及截图，盒子主播的福音",
  },
  {
    adName: "xcsAd2",
    url:
      "https://www.xiaocaishu.com/news/zi-dong-shi-bie-zu-hao-dang-da-fu-ti-sheng-gou-li-wu-de-zhun-que-du.html",
    imgSrc: require("../assets/pic/promo/xcs-2.jpg"),
    name: "自动识别租号党，大幅提升狗礼物的准确度",
  },
  {
    adName: "xcsAd3",
    url:
      "https://www.xiaocaishu.com/news/da-ge-wei-sha-hao-jiu-bu-lai-liao-fa-xian-ji-shi-huan-you-jiu.html",
    imgSrc: require("../assets/pic/promo/xcs-3.jpg"),
    name: "大哥为啥好久不来了，发现及时还有救",
  },
  {
    adName: "xcsAd4",
    url:
      "https://www.xiaocaishu.com/news/dui-yu-mo-sheng-da-ge-ru-he-ba-wo-hao-gou-li-wu-de-fen-cun.html",
    imgSrc: require("../assets/pic/promo/xcs-4.jpg"),
    name: "对于陌生大哥，如何把握好狗礼物的分寸？",
  },
  {
    adName: "xcsAd5",
    url:
      "https://www.xiaocaishu.com/news/zhi-bo-jian-de-xin-fang-ke-ru-he-xun-zhao-hua-ti-tu-po-kou.html",
    imgSrc: require("../assets/pic/promo/xcs-5.jpg"),
    name: "直播间的新访客，如何寻找话题突破口",
  },
];
export default {
  mixins: [commonFuc],
  data() {
    return {
      configure: null,
      featureList: null,
      accountList: {},
      cloudStatusTimer: {},
      cloudStartTimer: {},
      runStatusList: {},
      timer: null,
      isCloudLogin: true,
      isShowLogin: false,
      ticket: "",
      // F码相关
      FCodeArray: [],
      FCode: "",
      //广告相关
      adList: [
        // {
        //   adName: "bigData",
        //   url: "https://www.xiaohudi.com/news/da-shu-ju.html",
        //   imgSrc: require("../assets/pic/promo/promo-6.jpg"),
        //   name: "大数据",
        // },
        // {
        //   adName: "xcs",
        //   url:
        //     "https://www.xiaocaishu.com/news/da-ge-wei-sha-hao-jiu-bu-lai-liao-fa-xian-ji-shi-huan-you-jiu.html",
        //   imgSrc: require("../assets/pic/promo/promo-7.jpg"),
        //   name: "小财鼠",
        // },
        {
          adName: "seasonOrYear",
          url: "https://www.xiaohudi.com/news/ji-ka-fu-li.html",
          imgSrc: require("../assets/pic/promo/promo-5.jpg"),
          name: "季卡年卡",
        },
        {
          adName: "duty",
          url: "https://www.xiaohudi.com/news/xia-bo-zhi-shou.html",
          imgSrc: require("../assets/pic/promo/promo-4.jpg"),
          name: "下播值守",
        },
        {
          adName: "guessNum",
          url: "https://www.xiaohudi.com/news/cai-shu-zi.html",
          imgSrc: require("../assets/pic/promo/promo-3.jpg"),
          name: "猜点数",
        },
        {
          adName: "begGift",
          url: "https://www.xiaohudi.com/news/zhi-neng-gou.html",
          imgSrc: require("../assets/pic/promo/promo-2.jpg"),
          name: "智能狗",
        },
        {
          adName: "cloud",
          url: "https://www.xiaohudi.com/news/yun-duan-gua-ji.html",
          imgSrc: require("../assets/pic/promo/promo-1.jpg"),
          name: "云端挂机",
        },
      ],
      adStrategyComplete: false,
      roomId: "",
      isShowInputRoomId: "",
      // 通知识别
      isCurrentNotify: false,
      // 老用户召回领取F码
      isShowFcodeReceive: false,
      fcodeReceiveData: {
        FCode: "",
        pName: "",
        robotIndex: 0,
      },
      // 免费时间
      freeTime: 0,
      robotsCookieList: {},
    };
  },
  computed: {
    ...mapState({
      video: (state) => state.video,
      isPC: (state) => state.isPC,
      isWeixin: (state) => state.isWeixin,
      isElectron: (state) => state.isElectron,
      robotList: (state) => state.robotList,
      user: (state) => state.user,
      guideType: (state) => state.guideType,
    }),
    swiperOption() {
      if (this.adList.length <= 1) {
        return {
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          loop: false,
          autoplay: false,
          height: "auto",
        };
      } else {
        return {
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          loop: true,
          autoplay: {
            disableOnInteraction: false,
          },
          height: "auto",
        };
      }
    },
  },
  components: {
    accountLogin,
    payBox,
    inputRoomId,
    swiper,
    swiperSlide,
  },
  created() {
    if (this.isElectron) {
      this.getPageData();
    }
  },
  mounted() {
    this.changeLoadingStatus(true);
    this.ipcMonitor();
    if (!this.isElectron) {
      let isFirst = false;
      document.addEventListener("changed", () => {
        console.log(123, this.isCurrentNotify, isFirst);
        if (!this.isCurrentNotify) {
          if (isFirst) {
            this.getPageData();
          }
          isFirst = true;
        }
      });
      this.getPageData();
    }
    let query = this.$route.query;
    if (query.t && query.n) {
      this.fcodeReceiveData.FCode = query.t;
      // this.fcodeReceiveData.FCode = 'XN8inK7prCg5QwYFdhAhGvKPfgruFrI0'
      this.fcodeReceiveData.robotIndex = query.n;
      setTimeout(() => {
        getFCode({
          fcode: this.fcodeReceiveData.FCode,
        }).then((res) => {
          if (res.code === 0) {
            if (res.data.status == 0 && this.user.account == res.data.uid) {
              if (res.data.pname) {
                this.fcodeReceiveData.pName = res.data.pname;
                this.isShowFcodeReceive = true;
              } else {
                this.fcodeReceiveData.pName = "无效F码";
              }
            }
          }
        });
      }, 500);
    }
  },
  destroyed() {},
  watch: {
    // isShowLogin(val) {
    //     if (val) {
    //         this.getCloudQrCode();
    //     } else {
    //         clearInterval(this._cloudTimer);
    //     }
    // },
    // accountList: {
    //   handler: function(val, oldVal) {
    //     this.$forceUpdate()
    //   },
    //   deep: true
    // }
  },
  methods: {
    ...mapActions(["updateRobotList", "changeLoadingStatus"]),
    getPageData() {
      this.getUserRobots();
    },
    checkFreeTime(ticket, roomId) {
      checkFreeTime({
        ticket,
        roomId,
      }).then((res) => {
        if (res.code == 0) {
          this.freeTime = res.data.freeTime;
        }
      });
    },
    formatTime(time) {
      let theTime = parseInt(time); // 需要转换的时间秒
      let min = 0; // 分
      let hours = 0; // 小时
      if (theTime > 60) {
        min = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (min > 60) {
          hours = parseInt(min / 60);
          min = parseInt(min % 60);
          if (hours > 24) {
            //大于24小时
            hours = parseInt(hours % 24);
          }
        }
      }
      return `剩余时间${hours}小时${min}分钟`;
    },
    loginStatusChange(type = "") {
      this.accountList = localStorage["accountList"]
        ? JSON.parse(localStorage["accountList"])
        : {};
      if (type == "login") {
        this.isShowLogin = false;
      }
      if (type == "logout") {
        this.runStatusList[this.ticket].runStatus = false;
        this.runStatusList[this.ticket].status = 0;
      }
      this.$forceUpdate();
    },
    isAccountExpire(timestamp) {
      // let r = await new Promise((res) => {
      //     setTimeout(() => { res() }, 0);
      // });
      let timeStamp = parseInt((+new Date() - timestamp) / 86400000) >= 7;
      if (timeStamp) {
        return true;
      } else {
        return false;
      }
    },
    getUserRobots() {
      this.accountList = localStorage["accountList"]
        ? JSON.parse(localStorage["accountList"])
        : {};
      getUserRobotsInfo({ notify: false }).then(async (res) => {
        if (res.code === 0) {
          let robotList = [];
          let getNameList = [];
          this.configure = {};
          this.featureList = {};
          for (let i = 0; i < res.data.robots.length; i++) {
            let val = res.data.robots[i];
            let index = i;
            this.configure[val.ticket] = {
              label: `${index + 1}号机器人`,
              liveRoom: val.liveRoom,
            };
            if (val.remain != 0 && val.isCloud) {
              this.getConfig(val.ticket);
            }
            // 广告策略相关
            if (i == 0) {
              this.adStrategyComplete = false;
            }
            // 同步本地与线上状态
            if (this.accountList[val.ticket] && val.userInfo === undefined) {
              let data = this.accountList[val.ticket];
              this.accountList[val.ticket] = {
                cookies: data.cookie || data.cookies,
                timestamp: data.timestamp,
                user: data.user
                  ? {
                      name: data.user.userName,
                      userNick: data.user.userNick,
                      uid: data.user.uid,
                      level: data.user.level,
                      login_at: new Date(data.timestamp).toISOString(),
                      avatar: data.user.userLogo,
                      userLogo: data.user.userLogo,
                      noble_level: data.user.noble_level,
                      noble_name: data.user.noble_name,
                      noble_valid_date: data.user.noble_valid_date,
                      noble_status: data.user.noble_status,
                    }
                  : {
                      name: data.name,
                      userNick: data.userNick,
                      uid: data.uid,
                      level: data.level,
                      login_at: data.login_at,
                      avatar: data.avatar,
                      userLogo: data.userLogo,
                      noble_level: data.noble_level,
                      noble_name: data.noble_name,
                      noble_valid_date: data.noble_valid_date,
                      noble_status: data.noble_status,
                    },
              };
              localStorage["accountList"] = JSON.stringify(this.accountList);
              this.$forceUpdate();
              checkAccountType({
                ticket: val.ticket,
                roomId: val.liveRoom || localStorage.roomId,
              }).then((accountTypeRes) => {
                this.accountList[val.ticket].user.accountType =
                  accountTypeRes.code == 0 ? accountTypeRes.data.data : -1;
                localStorage["accountList"] = JSON.stringify(this.accountList);
                this.$forceUpdate();
              });
              updateAccount({
                ticket: val.ticket,
                accountUid: data.user ? data.user.uid : data.uid,
                cookie: data.cookie || data.cookies,
                userinfo: JSON.stringify(
                  data.user
                    ? {
                        name: data.user.userName,
                        userNick: data.user.userNick,
                        uid: data.user.uid,
                        level: data.user.level,
                        login_at: new Date(data.timestamp).toISOString(),
                        avatar: data.user.userLogo,
                        userLogo: data.user.userLogo,
                        noble_level: data.user.noble_level,
                        noble_name: data.user.noble_name,
                        noble_valid_date: data.user.noble_valid_date,
                        noble_status: data.user.noble_status,
                      }
                    : {
                        name: data.name,
                        userNick: data.userNick,
                        uid: data.uid,
                        level: data.level,
                        login_at: data.login_at,
                        avatar: data.avatar,
                        userLogo: data.userLogo,
                        noble_level: data.noble_level,
                        noble_name: data.noble_name,
                        noble_valid_date: data.noble_valid_date,
                        noble_status: data.noble_status,
                      }
                ),
              }).then((res) => {
                if (res.code == 0) {
                }
              });
            }
            if (this.accountList[val.ticket] && val.userInfo === null) {
              delete this.accountList[val.ticket];
              localStorage["accountList"] = JSON.stringify(this.accountList);
              this.$forceUpdate();
            }
            if (val.userInfo && !val.isCloud) {
              checkAccountType({
                ticket: val.ticket,
                roomId: val.liveRoom || localStorage.roomId,
              })
                .then((accountTypeRes) => {
                  let user = val.userInfo;
                  user.accountType =
                    accountTypeRes.code == 0 ? accountTypeRes.data.data : -1;
                  this.accountList[val.ticket] = {
                    cookies: val.cookies,
                    timestamp: +new Date(user.login_at),
                    user: user,
                  };
                  // console.log(val.ticket, this.runStatusList[val.ticket])
                  this.accountList[val.ticket].user.status = this.runStatusList[
                    val.ticket
                  ].runStatus
                    ? 1
                    : 0;
                  localStorage["accountList"] = JSON.stringify(
                    this.accountList
                  );
                  this.$forceUpdate();
                })
                .catch((err) => {
                  console.log(err);
                });
            }
            this.robotsCookieList[val.ticket] = val.cookies;
            robotList[i] = {
              label: `${index + 1}号机器人`,
              ticket: val.ticket,
              hasCloud: val.isCloud,
              timeRemaining:
                Math.ceil(val.remain / 86400) <= 0
                  ? parseInt(val.remain / 86400)
                  : parseInt(val.remain / 86400) + 1,
              roomId: val.liveRoom,
              // cloudLoading:
              //   this.robotList[i] &&
              //   this.robotList[i].cloudLoading &&
              //   this.runStatusList[val.ticket] &&
              //   !this.runStatusList[val.ticket].runStatus
              //     ? true
              //     : false,
              cloudLoading: true,
              huyaUserName: val.liveRoomName,
            };
            this.fetchRunStatus(val, robotList[i]);
            if (i == res.data.robots.length - 1) {
              this.updateRobotList(robotList);
              this.adStrategy(res.data.featureList, true);
              if (this.$route.params.type == "guide") {
                setTimeout(() => {
                  this.startRobot(robotList[0]);
                  this.$route.params.type = "";
                }, 500);
              }
              // loading.close();
              if (this.isElectron) {
                const resp = await manager.getAllLocalRobots();
                console.log(resp);
                setTimeout(() => {
                  robotList.forEach((sval, index) => {
                    if (resp[sval.ticket]) {
                      this.runStatusList[sval.ticket].runStatus = true;
                      this.runStatusList[sval.ticket].status = 1;
                      this.$forceUpdate();
                    }
                    console.log("getAllLocalRobots", this.runStatusList);
                  });
                }, 500);
              }
            }
          }
        }
      });
    },
    fetchRunStatus(val, json) {
      // if (this.isElectron) {
      //     if (!this.runStatusList[val.ticket]) {
      //         this.runStatusList[val.ticket] = {
      //             runStatus: false
      //         };
      //     }
      // } else {
      if (val.isCloud) {
        this.getCloudStatus(val, true, "status", json);
      } else {
        this.runStatusList[val.ticket] = {
          runStatus: false,
          status: 0,
        };
        console.log(this.runStatusList);
        json.cloudLoading = false;
        console.log(this.runStatusList, json);
      }
      // }
      this.$forceUpdate();
    },
    getRoomName(roomid) {
      return getRoomName(
        {
          roomId: roomid,
        },
        { notify: false }
      ).then((res) => {
        if (res.code == 0) {
          return res.data;
        }
        if (res.code == 500) {
          this.$message({
            dangerouslyUseHTMLString: true,
            type: "error",
            message:
              '<strong>找不到这个主播</strong><p style="margin-top: 5px;">请确认房间号是否正确</p>',
          });
        }
      });
    },
    linkToRenew(ticket) {
      this.$emit("showRenew", ticket);
    },
    openOfElectron(url) {
      if (!window.electron) return;
      let mainWindow = new window.electron.remote.BrowserWindow({
        height: 800,
        useContentSize: true,
        width: 1280,
        webPreferences: {
          nodeIntegration: true,
        },
      });
      mainWindow.on("closed", () => {
        mainWindow = null;
      });
      mainWindow.loadURL(url);
    },
    linkToConfig(ticket) {
      let url = `${location.origin}/config?ticket=${ticket}`;
      if (this.isElectron) {
        window.open(url);
      } else {
        if (this.isPC) {
          window.open(url);
          return;
        }
        this.$router.replace({
          path: "/config",
          query: {
            ticket,
          },
        });
      }
    },
    dialogBuyClose() {
      this.$refs.dialogbuy.hideDialog();
    },
    dialogPayClose() {
      this.$refs.dialogpay.hideDialog();
    },
    orderPayShow(json) {
      let self = this;
      json.ticket = this.ticket;
      if (this.isWeixin && !this.isPC) {
        createWechatPayOrder(json).then((res) => {
          if (res.code == 1000) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>创建订单失败</strong><p style="margin-top: 5px;">错误码「1000」，请联系客服</p>',
            });
          }
          if (res.code == 20001) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>商品不存在</strong><p style="margin-top: 5px;">错误码「20001」，请联系客服</p>',
            });
          }
          let orderId = res.data.orderId;
          createWechatPay({
            order_id: orderId,
          }).then((payData) => {
            if (payData.code == 70003) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>微信登录授权过期</strong><p style="margin-top: 5px;">请刷新，重新登录配置后台</p>',
              });
            }
            if (payData.code == 1000) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>创建公众号订单失败</strong><p style="margin-top: 5px;">错误码「1000」，请联系客服</p>',
              });
            }
            if (payData.code == 0) {
              let data = payData.data;
              wx.chooseWXPay({
                timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: data.paySign, // 支付签名
                success: function(res) {
                  // 支付成功后的回调函数
                  self.checkFcodeOrder(orderId);
                },
              });
            }
          });
        });
        return;
      }
      setTimeout(() => {
        this.$refs.dialogpay.showDialog(json);
      }, 0);
    },
    checkFcodeOrder(orderId) {
      checkFcodeOrder(
        {
          orderId: orderId,
        },
        { notify: false }
      ).then((res) => {
        if (res.code === 0) {
          if (res.data.paid) {
            if (!res.data.fcodes) {
              this.getPageData();
            } else {
              this.FCodeArray = res.data.fcodes;
              this.actionFCodeArray();
            }
          }
        }
      });
    },
    actionFCodeArray() {
      this.FCodeArray.forEach((val, index) => {
        setTimeout(() => {
          this.FCode = val.fcode;
          this.actionFCode();
          if (index == this.FCodeArray.length - 1) {
            this.FCodeArray = [];
            this.getPageData();
          }
        }, 100);
      });
    },
    actionFCode() {
      if (this.FCode.length != 32 && this.FCode.length != 10) {
        this.$message({
          dangerouslyUseHTMLString: true,
          type: "error",
          message:
            '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
        });
        return;
      }
      if (this.FCode) {
        consumeFCode({
          fcode: this.FCode,
          ticket: this.ticket,
        }).then((res) => {
          if (res.code == 0) {
            getFCode({
              fcode: this.FCode,
            }).then((resp) => {
              if (resp.code === 0) {
              }
              if (JSON.parse(getCookie("F_CODE"))) {
                this.$message({
                  type: "success",
                  dangerouslyUseHTMLString: true,
                  message: `已为您自动使用F码：<br/>${
                    JSON.parse(getCookie("F_CODE")).code
                  }`,
                });
                removeCookie("F_CODE");
              }
            });
            this.getPageData();
          } else {
            if (res.code == 20004) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码错误</strong><p style="margin-top: 5px;">F码错误请重新输入</p>',
              });
              // '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
            }
            if (res.code == 20005) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是公会版F码，请下载公会版使用</p>',
              });
            }
            if (res.code == 20006) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">新手体验码每个账号只能使用一张</p>',
              });
            }
            if (res.code == 20007) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是单功能F码，无法用于新增机器人</p>',
              });
            }
            if (res.code == 20008) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已被使用，如有疑问，请联系客服</p>',
              });
            }
            if (res.code == 20015) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验码仅限原账号使用</p>',
              });
            }
            if (res.code == 20016) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已过期，体验卡请在24小时内使用</p>',
              });
            }
            if (res.code == 20017) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验卡仅限给发码机器人使用</p>',
              });
            }
            if (JSON.parse(getCookie("F_CODE"))) {
              removeCookie("F_CODE");
            }
          }
        });
      } else {
        Message({
          showClose: true,
          message: "请输入F码",
        });
      }
    },
    payCompleted() {
      this.getUserRobots();
    },
    startRobot(json) {
      if (json.timeRemaining <= 0 && this.guideType != "tryout") {
        return this.$message.error("套餐已过期，请续费");
      }
      if (!json.hasCloud && !this.isElectron) {
        return this.$message.warning(
          "启动失败，电脑版机器人请在小虎弟客户端内启动。"
        );
      }
      if (!json.roomId) {
        return this.$message.error("请配置房间号");
      }
      if (json.cloudLoading) {
        json.cloudLoading = false;
        clearTimeout(this.cloudStatusTimer[json.ticket]);
        this.stopRobot(json);
        return;
        // this.$message.warning('正在启动中，请勿重复点击。')
      }
      this.accountList = localStorage["accountList"]
        ? JSON.parse(localStorage["accountList"])
        : {};
      let timestamp = this.accountList[json.ticket]
        ? this.accountList[json.ticket].timestamp
        : 0;
      if (this.isAccountExpire(timestamp)) {
        Message({
          showClose: true,
          message: `您的场控虎牙号登录授权已过期，请重新登录。`,
          type: "error",
        });
        setTimeout(() => {
          return this.accountExpireClick(json);
        }, 2e3);
        return;
      }
      checkAccountType({
        ticket: json.ticket,
        roomId: json.roomId || localStorage.roomId,
      }).then((res) => {
        if (res.code == 0) {
          if (res.data.data == 0) {
            this.$message({
              dangerouslyUseHTMLString: true,
              message:
                '您的场控号不是房管，发言过频容易「<a href="https://xiaohudi.com/entry/1.html?from=singlemessage&isappinstalled=0&scene=1&clicktime=1583721512&enterid=1583721512" target="_blank">吞字</a>」',
              type: "warning",
            });
          }
        }
      });
      console.log("startrobot", json, this.runStatusList);
      if (json.hasCloud) {
        this.cloudStart(json);
      } else {
        this.openElectronRobot(json);
      }
    },
    allStart() {
      this.robotList.forEach((val) => {
        this.startRobot(val);
      });
    },
    accountExpireClick(json) {
      if (json.timeRemaining <= 0 && this.guideType != "tryout") {
        return this.$message.error("套餐已过期，请续费");
      }
      this.roomId = json.huyaUserName ? json.roomId : "";
      this.ticket = json.ticket;
      if (json.hasCloud) {
        if (this.roomId) {
          this.isCloudLogin = true;
          this.isShowLogin = true;
        } else {
          this.isShowInputRoomId = true;
        }
      } else {
        if (this.isElectron) {
          if (this.roomId) {
            this.isCloudLogin = false;
            this.isShowLogin = true;
          } else {
            this.isShowInputRoomId = true;
          }
        } else {
          this.$message.warning("电脑版请在客户端内完成配置。");
        }
      }
    },
    stopRobot(json) {
      if (json.hasCloud) {
        this.pcRobotStop(json);
        this.cloudStop(json);
      } else {
        if (this.isElectron) {
          this.pcRobotStop(json);
        } else {
          this.$message.warning(
            "暂停失败，电脑版机器人请在小虎弟客户端内暂停。"
          );
        }
      }
    },
    async pcRobotStop(json) {
      if (this.isElectron) {
        const res = await manager.stopLocalRobot(json.ticket);
        if (res.code == -1) {
          this.cloudStop(json);
          return;
        }
        this.runStatusList[json.ticket].runStatus = false;
        this.runStatusList[json.ticket].status = 0;
        this.accountList[json.ticket].user.status = 0;
        localStorage["accountList"] = JSON.stringify(this.accountList);
        this.$forceUpdate();
      }
    },
    async openElectronRobot(json) {
      console.log("openElectronRobot", this.runStatusList);
      if (json.roomId) {
        let ticket = json.ticket;
        json.cloudLoading = true;
        const res = await manager.startLocalRobot({
          ticket: ticket,
          cookies: json.cookie || this.accountList[json.ticket].cookies,
          url: `https://www.huya.com/${json.roomId}`,
          account: this.user.account,
          name: this.configure[ticket].label,
          show: false,
        });
        if (res.code == 0) {
          Message({
            showClose: true,
            message: `${this.configure[ticket].label}启动成功`,
            type: "success",
          });
          this.robotList.forEach((val) => {
            if (val.ticket == ticket) {
              this.runStatusList[val.ticket].runStatus = true;
              this.runStatusList[val.ticket].status = 1;
              val.cloudLoading = false;
              this.$forceUpdate();
              if (this.cloudStatusTimer[val.ticket]) {
                clearTimeout(this.cloudStatusTimer[val.ticket]);
              }
            }
          });
          this.accountList[json.ticket].user.status = 1;
        } else {
          Message({
            showClose: true,
            message: res.message,
            type: "error",
          });
          this.robotList.forEach((val) => {
            if (val.ticket == ticket) {
              this.runStatusList[val.ticket].runStatus = false;
              this.runStatusList[val.ticket].status = 0;
              val.cloudLoading = false;
              this.$forceUpdate();
            }
          });
          this.accountList[json.ticket].user.status = 0;
        }
        localStorage["accountList"] = JSON.stringify(this.accountList);
        // this.openOfElectron(url);
      } else {
        this.$message({
          title: "提示",
          message: "请填写房间号",
          type: "error",
          duration: 2000,
        });
      }
    },
    cloudStart(json) {
      if (json.roomId) {
        // TODO
        json.cloudLoading = true;
        if (this.isElectron && this.configure[json.ticket].readText.enable) {
          this.getCloudStatus(json, true, "start");
        } else {
          cloudStart({
            url: json.roomId,
            ticket: json.ticket,
            query: +new Date(),
            // keeplive:
            // this.featureList[json.ticket]["duty"].isBuy &&
            // this.configure[json.ticket].duty.enable
          }).then((res) => {
            if (res.code == 0) {
              this.getCloudStatus(json, true);
              if (this.cloudStartTimer[json.ticket]) {
                clearTimeout(this.cloudStartTimer[json.ticket]);
              }
              this.cloudStartTimer[json.ticket] = setTimeout(() => {
                if (json.cloudLoading) {
                  this.$message({
                    dangerouslyUseHTMLString: true,
                    type: "error",
                    message:
                      '<strong>启动机器人超时</strong><p style="margin-top: 5px;">请重试，多次失败请联系客服</p>',
                  });
                  json.cloudLoading = false;
                }
              }, 2e4);
              // if (res.message) {
              //   this.$message.warning(res.message)
              // }
            } else if (res.code == 401) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>机器人启动失败</strong><p style="margin-top: 5px;">基础功能已过期，请续费。</p>',
              });
            } else if (res.code == 404) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>机器人启动失败</strong><p style="margin-top: 5px;">错误码「404」，请联系客服</p>',
              });
            } else if (res.code == 500) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>机器人启动失败</strong><p style="margin-top: 5px;">错误码「500」，请联系客服</p>',
              });
            } else if (res.code == 400) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>机器人启动失败</strong><p style="margin-top: 5px;">缺少房间号或场控号信息</p>',
              });
            }
          });
        }
      } else {
        this.$message.warning("请配置要服务的直播间地址");
      }
    },
    cloudStop(json) {
      cloudStop({ ticket: json.ticket, query: +new Date() }).then((res) => {
        this.runStatusList[json.ticket].runStatus = false;
        this.runStatusList[json.ticket].status = 0;
        this.$forceUpdate();
      });
    },
    getCloudStatus(json, loop = false, type = "default", robot = null) {
      this.runStatusList[json.ticket] = { runStatus: false };
      this.$forceUpdate();
      getCloudStatus(
        { ticket: json ? json.ticket : this.ticket, query: +new Date() },
        { notify: false }
      ).then((res) => {
        if (res.code == 0) {
          if (!loop) {
          }
          this.cloudStatus = res.data.status;
          if (type == "status") {
            robot.cloudLoading = false;
            this.runStatusList[json.ticket] = {
              runStatus:
                this.cloudStatus == 1 ||
                (this.cloudStatus == 4 &&
                  this.featureList &&
                  this.featureList[json.ticket] &&
                  this.featureList[json.ticket]["duty"].isBuy &&
                  this.configure &&
                  this.configure[json.ticket] &&
                  this.configure[json.ticket].duty.enable)
                  ? true
                  : false,
              status: this.cloudStatus,
            };
            if (res.data.status == 3) {
              delete this.accountList[json.ticket];
              localStorage["accountList"] = JSON.stringify(this.accountList);
              this.$forceUpdate();
              return;
            }
            if (res.data.user) {
              let user = res.data.user;
              delete user.cookie;
              user.status = this.cloudStatus;
              let data = {
                cookies: res.data.cookie,
                timestamp: res.data.loginAt,
                user,
              };
              if (!localStorage["accountList"]) {
                this.accountList = {};
              }
              // this.accountList[json.ticket] = data;
              // localStorage["accountList"] = JSON.stringify(this.accountList);
              this.$forceUpdate();
              if (this.robotsCookieList[json.ticket] != data.cookies) {
                this.accountList[json.ticket] = data;
                localStorage["accountList"] = JSON.stringify(this.accountList);
                this.$forceUpdate();
                checkAccountType({
                  ticket: json.ticket,
                  roomId:
                    this.configure[json.ticket].liveRoom || localStorage.roomId,
                }).then((accountTypeRes) => {
                  console.log(data);
                  data.user.accountType =
                    accountTypeRes.code == 0 ? accountTypeRes.data.data : -1;
                  this.accountList[json.ticket] = data;
                  localStorage["accountList"] = JSON.stringify(
                    this.accountList
                  );
                  this.$forceUpdate();
                });
                updateAccount({
                  ticket: json.ticket,
                  accountUid: data.user.uid,
                  cookie: data.cookies,
                  userinfo: JSON.stringify(data.user),
                }).then((res) => {});
              }
              this.accountList[json.ticket] = data;
              localStorage["accountList"] = JSON.stringify(this.accountList);
              this.$forceUpdate();
              checkAccountType({
                ticket: json.ticket,
                roomId:
                  this.configure[json.ticket].liveRoom || localStorage.roomId,
              }).then((accountTypeRes) => {
                console.log(data);
                data.user.accountType =
                  accountTypeRes.code == 0 ? accountTypeRes.data.data : -1;
                this.accountList[json.ticket] = data;
                localStorage["accountList"] = JSON.stringify(this.accountList);
                this.$forceUpdate();
              });
            }
            // this.$forceUpdate()
            return;
          }
          if (this.isElectron && type == "start") {
            if (this.cloudStatus == 2 || this.cloudStatus == 0) {
              if (res.data.cookie) {
                json.cloudLoading = true;
                this.openElectronRobot({
                  ticket: json.ticket,
                  cookie: res.data.cookie,
                  roomId: json.roomId,
                });
              }
            } else {
              Message({
                showClose: true,
                message: `云端版正在运行，请先到公众号配置后台停止云端机器人`,
                type: "error",
              });
            }
            return;
          }
          if (this.cloudStatusTimer[json.ticket]) {
            clearTimeout(this.cloudStatusTimer[json.ticket]);
          }
          this.cloudStatusTimer[json.ticket] = setTimeout(
            () => {
              this.getCloudStatus(json, true);
            },
            res.data.status == 1 ? 12e3 : json.cloudLoading ? 2e3 : 10e3
          );
          if (res.data.status === 1) {
            if (json.cloudLoading) {
              Message({
                showClose: true,
                message: `${this.configure[json.ticket].label}启动成功`,
                type: "success",
              });
            }
            json.cloudLoading = false;
            this.runStatusList[json.ticket].runStatus = true;
            this.runStatusList[json.ticket].status = 1;
            this.$forceUpdate();
            if (this.cloudStatusTimer[json.ticket]) {
              clearTimeout(this.cloudStatusTimer[json.ticket]);
            }
          }
          if (res.data.status === 3) {
            Message({
              showClose: true,
              message: res.data.error,
              type: "error",
            });
            if (this.cloudStatusTimer[json.ticket]) {
              clearTimeout(this.cloudStatusTimer[json.ticket]);
            }
            delete this.accountList[json.ticket];
            localStorage["accountList"] = JSON.stringify(this.accountList);
          }
          if (res.data.status === 4) {
            if (json.cloudLoading) {
              Message({
                showClose: true,
                message: `${
                  this.configure[json.ticket].label
                }启动失败，主播尚未开播。如需「下播值守」，请在配置后台开通。`,
                type: "error",
              });
            }
            json.cloudLoading = false;
            this.runStatusList[json.ticket].runStatus = false;
            this.runStatusList[json.ticket].status = 0;
            this.$forceUpdate();
            if (this.cloudStatusTimer[json.ticket]) {
              clearTimeout(this.cloudStatusTimer[json.ticket]);
            }
          }
        } else {
          if (type == "status") {
            robot.cloudLoading = false;
          }
          if (this.cloudStatusTimer[json.ticket]) {
            clearTimeout(this.cloudStatusTimer[json.ticket]);
          }
          if (res.code == 404) {
            json.cloudLoading = false;
            this.runStatusList[json.ticket] = { runStatus: false };
            delete this.accountList[json.ticket];
            localStorage["accountList"] = JSON.stringify(this.accountList);
            this.$forceUpdate();
            if (type == "start") {
              this.isShowLogin = true;
              this.isCloudLogin = true;
            }
          }
        }
      });
    },
    // 广告策略
    adStrategy(features, isEnd) {
      if (this.adList.length) {
        Object.keys(features).forEach((val, arrayindex) => {
          let index = this.adList.findIndex((item) => {
            return item.adName.toLocaleLowerCase() == val.toLocaleLowerCase();
          });
          if (!!~index) {
            this.adList.splice(index, 1);
          }
          if (isEnd && arrayindex == Object.keys(features).length - 1) {
            bigAmount()
              .then((res) => {
                if (res.code == 0) {
                  if (res.data.status) {
                    let index = this.adList.findIndex((item) => {
                      return (
                        item.adName.toLocaleLowerCase() ==
                        "seasonOrYear".toLocaleLowerCase()
                      );
                    });
                    if (!!~index) {
                      this.adList.splice(index, 1);
                    }
                  }
                }
                this.adList.splice(
                  1,
                  0,
                  xcsAdList[Math.round(Math.random() * (xcsAdList.length - 1))]
                );
                this.adStrategyComplete = true;
                this.changeLoadingStatus(false);
              })
              .catch((e) => {
                this.adStrategyComplete = true;
                this.changeLoadingStatus(false);
              });
          }
        });
      } else {
        this.changeLoadingStatus(false);
      }
    },
    getConfig(ticket, type = "", isEnd = false) {
      getConfig(
        {
          ticket: ticket,
        },
        { notify: false }
      ).then((res) => {
        if (res.code == 0) {
          //   if (type == 'ad') {
          // this.adStrategy(res.data.features, isEnd)
          //   }
          const configure = res.data.configure;
          let d = JSON.parse(configure);
          if (this.configure[ticket] == null) {
            this.configure[ticket] = d;
          } else {
            Object.assign(this.configure[ticket], d);
          }
          this.configure[ticket].features = res.data.features;
          this.getFeaturList(ticket);
        }
      });
    },
    getFeaturList(ticket) {
      getFeatureList(null, { notify: false }).then((res) => {
        if (res.code == 0) {
          const featureList = res.data.featureList;
          this.featureList[ticket] = {};
          featureList.forEach((val, index) => {
            this.featureList[ticket][val.jsonField] = val;
            this.featureList[ticket][val.jsonField].isBuy = this.configure[
              ticket
            ].features[val.jsonField]
              ? true
              : false;
            this.featureList[ticket][val.jsonField].timeRemaining = Math.ceil(
              (this.configure[ticket].features[val.jsonField] * 1000 -
                +new Date()) /
                86400000
            );
            if (this.configure[ticket][val.jsonField]) {
              this.configure[ticket][val.jsonField] = deepObjectMerge(
                JSON.parse(val.defaultData),
                this.configure[ticket][val.jsonField]
              );
            } else {
              this.$set(
                this.configure[ticket],
                val.jsonField,
                deepObjectMerge({}, JSON.parse(val.defaultData))
              );
            }
          });
        }
      });
    },
    ipcMonitor() {
      if (window.electron) {
        manager.on("start", (ticket) => {
          console.log(1, "start", this.runStatusList, ticket, this);
          this.$set(this.runStatusList, ticket, {
            runStatus: true,
            status: 1,
          });
          // this.runStatusList[ticket].runStatus = true;
          // this.runStatusList[ticket].status = 1;
          this.$forceUpdate();
        });
        manager.on("stop", (ticket) => {
          console.log(2, "stop", this);
          this.$set(this.runStatusList, ticket, {
            runStatus: false,
            status: 0,
          });
          // this.runStatusList[ticket].runStatus = false;
          // this.runStatusList[ticket].status = 0;
          this.$forceUpdate();
        });
        manager.on("show", (ticket) => {});
        manager.on("hide", (ticket) => {});
        window.electron.ipcRenderer.on("refreshData", (e, data) => {
          console.log(3, "refreshData");
          this.accountList = localStorage["accountList"]
            ? JSON.parse(localStorage["accountList"])
            : {};
          this.getUserRobots();
        });
      } else {
        setTimeout(() => {
          this.ipcMonitor();
        }, 1000);
      }
    },
    save() {
      this.$refs.inputroomid.save();
    }, // 保存配置
    saveCompleted() {
      this.isShowInputRoomId = false;
      this.getUserRobots();
    },
    openDownloadPage() {
      window.open("https://www.xiaohudi.com/download.html");
    },
    accountLoginSuccess() {
      this.isShowLogin = false;
      this.getUserRobots();
    },
    changed() {
      console.log("changed");
    },
    async openLiveRoom(roomurl, ticket, json) {
      console.log(roomurl, ticket, this.configure[ticket]);
      if (roomurl) {
        if (
          (this.isElectron && !json.hasCloud) ||
          (this.isElectron &&
            json.hasCloud &&
            this.configure[json.ticket].readText.enable)
        ) {
          const res = await manager.showLocalRobot(ticket);
          console.log(res);
          if (res.code != 0) {
            this.$message({
              title: "提示",
              message: res.message,
              type: "error",
              duration: 2000,
            });
          }
        } else {
          let url = `https://www.huya.com/${roomurl}`;
          if (this.isElectron) {
            url = `${url}${
              this.accountList[json.ticket] &&
              this.accountList[json.ticket].cookies
                ? `?cookies=${encodeURIComponent(
                    this.accountList[json.ticket].cookies
                  )}`
                : ""
            }`;
          }
          window.open(url);
        }
      } else {
        this.$message({
          title: "提示",
          message: "请填写房间号",
          type: "error",
          duration: 2000,
        });
      }
    },
    changeCurrentNotify(bool) {
      this.isCurrentNotify = bool;
    },
    fcodeReceive() {
      consumeFCode({
        fcode: this.fcodeReceiveData.FCode,
        ticket: this.robotList[this.fcodeReceiveData.robotIndex].ticket,
      }).then((res) => {
        if (res.code == 0) {
          Message({
            showClose: true,
            message: `使用成功`,
            type: "success",
          });
          this.$emit("completeFcode");
        } else {
          if (res.code == 20004) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>F码错误</strong><p style="margin-top: 5px;">F码错误请重新输入</p>',
            });
            // '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
          }
          if (res.code == 20005) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是公会版F码，请下载公会版使用</p>',
            });
          }
          if (res.code == 20006) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>F码使用失败</strong><p style="margin-top: 5px;">新手体验码每个账号只能使用一张</p>',
            });
          }
          if (res.code == 20007) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是单功能F码，无法用于新增机器人</p>',
            });
          }
          if (res.code == 20008) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已被使用，如有疑问，请联系客服</p>',
            });
          }
          if (res.code == 20015) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验码仅限原账号使用</p>',
            });
          }
          if (res.code == 20016) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已过期，体验卡请在24小时内使用</p>',
            });
          }
          if (res.code == 20017) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验卡仅限给发码机器人使用</p>',
            });
          }
        }
        this.isShowFcodeReceive = false;
      });
    },
    handleCommand(command, item) {
      if (command == "delete") {
        this.$confirm(`确定要删除机器人吗？该操作不可逆`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.delRobot(item);
          })
          .catch(() => {});
      }
    },
    delRobot(item) {
      console.log(item);
      delRobot({
        ticket: item.ticket,
        code: item.code || "",
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.$notify({
            title: "提示",
            message: "删除成功",
            type: "success",
            duration: 2000,
          });
          delete this.runStatusList[item.ticket];
          this.getPageData();
          this.$emit("getUser");
        } else {
          this.$notify({
            title: "提示",
            message: res.message,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
  },
};
</script>
